import { render, staticRenderFns } from "./CDropdown.vue?vue&type=template&id=3c8efb05&scoped=true"
import script from "./CDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./CDropdown.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CDropdown.vue?vue&type=style&index=0&id=3c8efb05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8efb05",
  null
  
)

export default component.exports